import { SimpleDocCommand } from '../DocsApp/commands/v5/types';
import { CommandExecutionContext } from '../../types/commands';
import { StandardToolResult } from '../../types/standardToolResults';
import fetchService from '../../services/fetchService';
import { API_BASE_URL } from '../../api/config';
import { MANIFEST } from './slack_find_user.m';
import { schemaToParameters } from '../../utils/schemaToParameters';

const log = { log: (...a: any[]) => console.log('[SLACK_QUERY_TOOL]', ...a) };

export const slack_find_user: SimpleDocCommand = {
  id: MANIFEST.name,
  logicalName: 'slack_find_user',
  version: 'v1',
  description: MANIFEST.description,

  schema: {
    parameters: schemaToParameters(MANIFEST.inputSchema),
  },

  handler: async (params: any, _context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { query, workspaceId } = params;

    if (!query?.trim()) {
      return { status: 'error', message: 'query is required', format: 'plaintext' };
    }

    try {
      const data = await fetchService(`${API_BASE_URL}/integrations/slack/find-user`, {
        method: 'POST',
        body: JSON.stringify({ query, workspaceId }),
      });

      if (data.error || data.detail) {
        const detail = data.detail || data.error;
        return {
          status: 'error',
          message: detail.includes('not connected')
            ? 'Slack is not connected. Connect a workspace in Settings → Integrations.'
            : `Slack find-user failed: ${detail}`,
          error: { code: 'find_user_failed', category: 'execution', details: detail },
          format: 'plaintext',
        };
      }

      if (!data.userId) {
        log.log(`find-user: no match for "${query}"`);
        return {
          status: 'success',
          message: `No Slack user found matching "${query}"`,
          data: { userId: null, query, workspaceId: data.workspaceId },
          format: 'json',
        };
      }

      log.log(`find-user: found ${data.userId} for "${query}"`);
      return {
        status: 'success',
        message: `Found Slack user: ${data.realName || data.name}`,
        data,
        format: 'json',
      };
    } catch (error: any) {
      const detail = error.data?.detail || error.message || 'Unknown error';
      return {
        status: 'error',
        message: detail.includes('not connected')
          ? 'Slack is not connected. Connect a workspace in Settings → Integrations.'
          : `Slack find-user failed: ${detail}`,
        error: { code: 'error', category: error.status === 400 ? 'validation' : 'execution', details: detail },
        format: 'plaintext',
      };
    }
  },
};
